import cn from "classnames";
import Image from "next/image";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

import { LOADING_SKELETON_CONFIG } from "@config/config";
import emptyCmsPageSvg from "@images/svg/empty-cms-page.svg";
import Button from "@ui-kit/Button/Button";

import s from "./LoadingPage.module.scss";

const LoadingPage = ({ openPageStrucrute }) => {
  return (
    <div className={cn(s.loadingPage)}>
      <SkeletonTheme {...LOADING_SKELETON_CONFIG}>
        <div className={cn(s.content)}>
          <div className={s.image}>
            <Skeleton height={120} width={320} />
          </div>
          <div className={s.title}>
            <Skeleton height={24} width={400} />
          </div>
          <div className={s.subTitle}>
            <Skeleton height={14} width={450} />
          </div>
          <div className={s.subTitle}>
            <Skeleton height={14} width={350} />
          </div>
          <div className={s.button}>
            <Skeleton height={40} width={120} />
          </div>
        </div>
      </SkeletonTheme>
    </div>
  );
};

export default LoadingPage;
